import { render, staticRenderFns } from "./CopyQuestionsModal.vue?vue&type=template&id=d36c73d8&"
import script from "./CopyQuestionsModal.vue?vue&type=script&lang=js&"
export * from "./CopyQuestionsModal.vue?vue&type=script&lang=js&"
import style0 from "./CopyQuestionsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {LoadingOverlay: require('/lasso/components/LoadingOverlay.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d36c73d8')) {
      api.createRecord('d36c73d8', component.options)
    } else {
      api.reload('d36c73d8', component.options)
    }
    module.hot.accept("./CopyQuestionsModal.vue?vue&type=template&id=d36c73d8&", function () {
      api.rerender('d36c73d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/shared/CopyQuestionsModal.vue"
export default component.exports